// extracted by mini-css-extract-plugin
module.exports = {"about":"styles-module--about--aTzL8","stats":"styles-module--stats--3rl8O"};